export const PERIODS = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  FOUR_WEEKS: 'FOUR_WEEKS',
  MAX: 'MAX',
} as const;

export type Period = (typeof PERIODS)[keyof typeof PERIODS];

// dropdown options
export const PERIOD_OPTIONS: { label: string; value: Period }[] = [
  { label: 'Day', value: PERIODS.DAY },
  { label: 'Week', value: PERIODS.WEEK },
  { label: 'Four weeks', value: PERIODS.FOUR_WEEKS },
  { label: 'Project', value: PERIODS.MAX },
];

export const PERIOD_DISPLAY_LABELS: Record<Period, string> = {
  DAY: 'Data shown is daily',
  WEEK: 'Data shown is weekly',
  FOUR_WEEKS: 'Data shown is over 4 weeks',
  MAX: 'Data shown is for the entire project',
};
